const themes = ["ambiance", "github", "kr_theme", "monokai"]
const defaultTheme = "kr_theme"

export { defaultTheme, themes }
